import { render, staticRenderFns } from "./RoomScheduleSettingExampleModal.vue?vue&type=template&id=6b5179dc&lang=pug"
import script from "./RoomScheduleSettingExampleModal.vue?vue&type=script&lang=ts"
export * from "./RoomScheduleSettingExampleModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports